import { render, staticRenderFns } from "./ProjectPartnerList.vue?vue&type=template&id=d2d13244&"
import script from "./ProjectPartnerList.vue?vue&type=script&lang=js&"
export * from "./ProjectPartnerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports